import React from 'react';
import SVGLoader, {
  SVGLoaderProps,
} from '@rsos/base-assets/icons/src/SVGLoader';

const defaults = {
  width: 16,
  height: 16,
  viewboxWidth: 16,
  viewboxHeight: 16,
};

const ResourcesHubIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}: SVGLoaderProps) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <path
        d="M2.53438 11.5266L2.55981 9.30103C1.41606 9.10221 0.573113 8.1017 0.573113 6.94322C0.573113 5.63028 1.65572 4.54994 2.97143 4.54994C3.45732 4.54994 3.93193 4.69733 4.3321 4.97246L6.66389 2.54725C6.51198 2.30221 6.43147 2.01952 6.43147 1.73128C6.43147 0.880527 7.13294 0.180359 7.98566 0.180359C8.83821 0.180359 9.53985 0.880527 9.53985 1.73128C9.53985 2.58204 8.83821 3.28221 7.98566 3.28221C7.71854 3.28221 7.45614 3.21347 7.22339 3.08288L4.89177 5.50809C5.06709 5.74036 5.19829 6.00271 5.27913 6.28221L11.0102 5.60506C11.0886 4.54759 11.9825 3.71935 13.045 3.71935C14.1644 3.71935 15.0854 4.63851 15.0854 5.75549C15.0854 6.87246 14.1644 7.79162 13.045 7.79162C12.1588 7.79162 11.3692 7.21549 11.1006 6.3728L5.37025 7.03582C5.35476 7.45078 5.23063 7.85448 5.01033 8.20658L8.79762 11.5679C9.22608 11.2195 9.76217 11.0291 10.3148 11.0291C11.6321 11.0291 12.7161 12.1108 12.7161 13.4254C12.7161 14.74 11.6321 15.8217 10.3148 15.8217C8.99737 15.8217 7.91341 14.74 7.91341 13.4254C7.91341 12.9733 8.04158 12.5304 8.28309 12.1479L4.48907 8.79784C4.15745 9.06927 3.75846 9.24641 3.33455 9.31095L3.30928 11.5358C4.06313 11.7214 4.59703 12.4017 4.59703 13.1765C4.59703 14.1036 3.83257 14.8664 2.90355 14.8664C1.97454 14.8664 1.21008 14.1036 1.21008 13.1765C1.21008 12.3879 1.76335 11.6992 2.53455 11.5272L2.53438 11.5266ZM7.98297 2.50843C8.40907 2.50843 8.75956 2.15868 8.75956 1.73347C8.75956 1.30826 8.40907 0.95851 7.98297 0.95851C7.55686 0.95851 7.20638 1.30826 7.20638 1.73347C7.20671 2.15851 7.55703 2.50809 7.98297 2.50843ZM13.0459 7.01784C13.7404 7.01784 14.3121 6.44742 14.3121 5.75431C14.3121 5.0612 13.7404 4.49078 13.0459 4.49078C12.3513 4.49078 11.7797 5.0612 11.7797 5.75431C11.7805 6.44708 12.3516 7.017 13.0459 7.01784ZM10.3119 15.042C11.2023 15.042 11.9353 14.3108 11.9353 13.4222C11.9353 12.5336 11.2025 11.8024 10.3121 11.8024C9.42162 11.8024 8.68882 12.5336 8.68882 13.4222C8.68966 14.3104 9.42179 15.041 10.3119 15.042ZM2.90339 14.0908C3.40663 14.0906 3.82078 13.6773 3.82078 13.1751C3.82078 12.6728 3.40663 12.2595 2.90322 12.2595C2.39981 12.2595 1.98566 12.6728 1.98566 13.1751C1.98617 13.6773 2.40014 14.0903 2.90339 14.0908Z"
        fill="currentColor"
      />
    </SVGLoader>
  );
};

export default ResourcesHubIcon;
